import { GridColDef } from '@mui/x-data-grid';
import { TableField } from '../data/Constants';

import type { IMarket, IMarketRow } from '../../types';

/**
 * Create Rows for Product Table
 * @param {IMarket[]} markets Markets list
 * @param {number} page Current page number
 * @param {number} limit Records per page
 * @param {string[]} updatedMarkets Updated markets array
 * @returns {IMarketRow[]} Market rows for display
 */
export function createRows(
  markets: IMarket[],
  page: number,
  limit: number,
  updatedMarkets?: string[]
) {
  const rows: IMarketRow[] = [];
  let count = 1;
  markets?.forEach((market: IMarket) => {
    if (count > (page - 1) * limit && count <= page * limit) {
      rows.push({
        id: market.code,
        [TableField.code]: market.code,
        [TableField.country]: market.name,
        [TableField.quote]: updatedMarkets?.includes(market.code) ? 'Y' : 'N',
      });
    }
    count++;
  });
  return rows;
}

/**
 * To show specific columns in Toggable Columns menu
 * @param {GridColDef[]} cols Grid column definitions
 * @returns {string[]} Array of column field names that can be toggled
 */
export const getTogglableColumns = (cols: GridColDef[]) => {
  return cols
    .filter((column) => !column.field.includes(TableField.rfq))
    .map((column) => column.field);
};
